export const REGISTER = "REGISTER";
export const LOGIN = "LOGIN";
export const SET_CREDS = "SET_CREDS";
